import { Image } from 'expo-image'
import { View } from 'react-native'
import Animated, {
  interpolate,
  ReduceMotion,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated'

import { Typography } from '@/src/elements/text/Typography'
import { useTimeout } from '@/src/general/hooks/useTimeout'
import { useTranslate } from '@/src/lang/useTranslate'

export const StepThree = () => {
  const positionProgress = useSharedValue(0)
  const widthProgress = useSharedValue(0)
  const { t } = useTranslate()

  useTimeout(() => {
    positionProgress.value = withTiming(1, { duration: 800, reduceMotion: ReduceMotion.System })
    widthProgress.value = withTiming(1, { duration: 500, reduceMotion: ReduceMotion.System })
  }, 800)

  const firstImageAnimatedStyle = useAnimatedStyle(() => ({
    width: interpolate(widthProgress.value, [0, 1], [154, 100]),
    transform: [{ translateY: interpolate(positionProgress.value, [0, 1], [0, -2]) }],
  }))

  const secondImageAnimatedStyle = useAnimatedStyle(() => ({
    width: interpolate(widthProgress.value, [0, 1], [171, 100]),
    transform: [
      { translateX: interpolate(positionProgress.value, [0, 1], [0, -3]) },
      { translateY: interpolate(positionProgress.value, [0, 1], [0, -35]) },
    ],
  }))

  const thirdImageAnimatedStyle = useAnimatedStyle(() => ({
    width: interpolate(widthProgress.value, [0, 1], [171, 100]),
    transform: [
      { translateX: interpolate(positionProgress.value, [0, 1], [0, -3]) },
      { translateY: interpolate(positionProgress.value, [0, 1], [0, 35]) },
    ],
  }))

  return (
    <>
      <Typography size="lg" black colors="primary" contrast="default" className="mx-6 mt-2">
        {t('prayer-space.onboarding.step-3.title')}
      </Typography>
      <View className="my-6 h-[168px] w-full">
        <Animated.View
          className="absolute rounded-2xl shadow-md"
          style={[
            {
              left: 24,
              top: 37,
              height: 98,
            },
            firstImageAnimatedStyle,
          ]}
        >
          <Image
            source={require('@/img/onboarding/frame-16066.webp')}
            contentFit="cover"
            className="h-full w-full rounded-2xl"
          />
        </Animated.View>
        <Animated.View
          className="absolute rounded-2xl shadow-md"
          style={[
            {
              left: 145,
              top: 70,
              height: 98,
            },
            secondImageAnimatedStyle,
          ]}
        >
          <Image
            source={require('@/img/onboarding/frame-16067.webp')}
            contentFit="cover"
            className="h-full w-full rounded-2xl"
          />
        </Animated.View>
        <Animated.View
          className="absolute rounded-2xl shadow-md"
          style={[
            {
              left: 262,
              top: 0,
              height: 98,
            },
            thirdImageAnimatedStyle,
          ]}
        >
          <Image
            source={require('@/img/onboarding/frame-16068.webp')}
            contentFit="cover"
            className="h-full w-full rounded-2xl"
          />
        </Animated.View>
      </View>
      <Typography colors="primary" contrast="high" className="mx-6" size="sm">
        {t('prayer-space.onboarding.step-3.description')}
      </Typography>
    </>
  )
}
